import React, { useState, useEffect } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import {
    DropdownMenu,
    DropdownToggle,
    Container,
    Navbar,
    UncontrolledDropdown,
    Table,
    Row,
    Breadcrumb,
    Col,
    BreadcrumbItem,
    Spinner,
    DropdownItem,
    Media,
    Card,
    CardBody,
} from 'reactstrap';
import { fetcher } from 'api/client';
import { fetchRisks } from 'api/actions/risks';
import { formatDistanceToNow, parseDate } from 'utils';
import { useTranslation } from 'react-i18next';
import Pagination from 'components/Shared/Paginator';
import { MainHeader } from 'components/Shared/MainHeader';

function Risk({ risk }) {
    const { t } = useTranslation();
    const { contract, description, type, days, status, closedAt, user, updatedAt } = risk;
    return (
        <tr>
            <td>
            </td>
            <td>
            </td>
            <td>
                {contract.name}
                <span className="text-muted">
                    <b>{description}</b> - {t('risks.type.' + type)}
                </span>
            </td>
            <td>
                {contract.status && t('contracts.status.' + contract.status)}
                {/* {!contract.status && contract.importedPdf ?
                    t('contracts.status.LOADED') :
                    t('contracts.status.EMPTY')} */}
            </td>
            <td>
                {formatDistanceToNow(updatedAt)}
            </td>
            <td>
                {days}
            </td>
            <td>
                {status === 'closed' ?
                    <>
                        <span className="text-success">
                            {t(`risks.status.${status}`)} <i className="fas fa-check"></i>
                        </span>
                        <span className="text-muted block">
                            <small>{parseDate(closedAt, 'P')}</small>
                        </span>
                    </>
                    :
                    <span className="text-danger">
                        {t(`risks.status.${status}`)} <i className="fas fa-exclamation-triangle"></i>
                    </span>
                }
            </td>
            <td>
                {user?.givenName} {user?.familyName}
            </td>
            <td></td>
        </tr>
    )
}

export default function Risks() {

    const [filter, setfilter] = useState('opened')
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    const handleChange = (state) => {
        setfilter(state);
    }

    useEffect(() => {
        queryClient.invalidateQueries('risks-fetch', filter)
    }, [filter])

    const { data: risks, isSuccess } = useQuery(['risks-fetch', filter], () => fetcher(fetchRisks(filter)));

    return (
        <>
            <MainHeader title="risks.title">
            </MainHeader>
            <Media>
                <Media className="w-100">
                    <Breadcrumb tag="nav" className="font-weight-bold">
                        <BreadcrumbItem>
                            {t('risks.listing.title')}
                        </BreadcrumbItem>
                    </Breadcrumb>
                </Media>
                <Media>
                    <UncontrolledDropdown className="float-right" direction="left">
                        <DropdownToggle color="none" caret>
                            <span>{t('risks.search.filter')}: {t(`risks.status.${filter}`)}</span>
                        </DropdownToggle>
                        <DropdownMenu >
                            <DropdownItem onClick={() => handleChange('opened')}>{t('risks.status.opened')}</DropdownItem>
                            <DropdownItem onClick={() => handleChange('closed')}>{t('risks.status.closed')}</DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </Media>
            </Media>
            <Card className="rounded-lg card-shadow">
                <CardBody className="p-4 mt-2">
                    <Table size="sm" className="bg-white">
                        <thead>
                            <tr>
                                <th></th>
                                <th>{t('risks.listing.header_type')}</th>
                                <th>{t('risks.listing.header_name')}</th>
                                <th>{t('risks.listing.header_contract_status')}</th>
                                <th>{t('risks.listing.header_updated')}</th>
                                <th>{t('risks.listing.header_days')}</th>
                                <th>{t('risks.listing.header_status')}</th>
                                <th>{t('risks.listing.header_owner')}</th>
                                <th>{t('risks.listing.header_actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {isSuccess ?
                                risks.length ?
                                    risks.map((risk, key) => <Risk key={`risk${key}`} risk={risk} />) :
                                    <tr className="text-center"><td colSpan="20">{t('risks.listing.empty')}</td></tr>
                                :
                                <tr className="text-center">
                                    <td colSpan="20">
                                        <Spinner size="sm" />{' '}{t('risks.listing.loading')}
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                    <div className="text-center bg-white border-top sticky-bottom">
                        <Pagination
                            page="1"
                            total="1"
                            isDisabled={true}
                            onNextPage={() => { }}
                            onPrevPage={() => { }}
                            onPageClick={() => { }} />
                    </div>
                </CardBody>
            </Card>
        </>
    )
}